import { useQuery } from "@tanstack/react-query";
import {
  type EntityListOfSocialUserSummary,
  getSocialBlocks,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { SOCIAL_LIST_PAGE_SIZE } from "Pages/People/constants";

export const blockedKeys = {
  all: ["SOCIAL_BLOCKED"] as const,
  page: (pageNumber: number) => [...blockedKeys.all, pageNumber] as const,
};

/**
 * A page of the personas the caller has blocked (who blocked the CALLER is never
 * disclosed by the API).
 */
export const useBlockedUsersQuery = (pageNumber = 1) =>
  useQuery<EntityListOfSocialUserSummary>({
    queryKey: blockedKeys.page(pageNumber),
    queryFn: processResponseWithApiProblemDetails(() =>
      getSocialBlocks(SOCIAL_LIST_PAGE_SIZE, pageNumber),
    ),
  });
